import { BannerObjData } from "@hypexone/uicore/lib/cjs/src/models/Banners";
import MainBanner1 from "../../../assets/images/home-images/main-banner-1.webp";

/** HA CMS category used for Skyexch home page carousel banners. */
export const HOME_BANNER_CATEGORY = "skyexchHomeBanner";

/** HA CMS categories for the casino lobby pages ("Casino", "Indian Casino"). */
export const CASINO_BANNER_CATEGORY = "Casinobanner";
export const INDIAN_CASINO_BANNER_CATEGORY = "indiancasinobanner";

/** For pages that show nothing until HA has a banner uploaded. */
export const NO_DEFAULT_BANNERS: BannerObjData[] = [];

type DefaultBannerSeed = {
  id: number;
  title: string;
  publicUrl: string;
  redirectionUrl: string;
};

const createDefaultBanner = (
  seed: DefaultBannerSeed,
  deviceType: "desktop" | "mobile"
): BannerObjData =>
  ({
    id: deviceType === "desktop" ? seed.id : seed.id - 1000,
    bannerId: `default_${seed.title.toLowerCase().replace(/\s+/g, "_")}_${deviceType}`,
    title: seed.title,
    category: HOME_BANNER_CATEGORY,
    deviceType,
    publicUrl: seed.publicUrl,
    redirectionUrl: seed.redirectionUrl,
    active: true,
  }) as BannerObjData;

const DEFAULT_BANNER_SEEDS: DefaultBannerSeed[] = [
  {
    id: -1,
    title: "Get Your Online ID",
    publicUrl: MainBanner1,
    redirectionUrl: "nourl",
  },
];

/** Built-in home banner — shown only when HA returns no banners. */
export const DEFAULT_HOME_BANNERS: BannerObjData[] = DEFAULT_BANNER_SEEDS.flatMap(
  (seed) => [
    createDefaultBanner(seed, "desktop"),
    createDefaultBanner(seed, "mobile"),
  ]
);
